<template>
  <div>
    <v-radio
      v-for="choice in currentQuestion.data.choices"
      :key="choice"
      v-model="answer"
      :label="choice"
      :value="choice"
    ></v-radio>
    <v-radio
      v-if="currentQuestion.data.otherChoice"
      :label="currentQuestion.data.otherLabel"
      v-model="answer"
      :value="currentQuestion.data.otherLabel"
    ></v-radio>
    <v-text-field
      label="Précisez"
      v-model="comment"
      v-if="answer === currentQuestion.data.otherLabel"
      style="margin-top: -1.5rem; margin-left: 2.3rem;"
      required
    ></v-text-field>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import _ from "lodash";
  export default {
    name: "SingleChoice",
    data: () => ({
      answer: null,
      comment: ``,
    }),
    computed: {
      ...mapState([
        `currentQuestion`,
      ]),
    },
    methods: {
      clear () {
        this.answer = null;
        this.comment = null;
      },
    },
    watch: {
      answer (newAnswer) {
        let canValidate = Boolean(newAnswer);
        if (newAnswer === this.currentQuestion.data.otherLabel) {
          canValidate = canValidate && Boolean(this.comment);
        } else {
          this.comment = ``;
        }
        this.$emit(`canValidate`, canValidate);
        this.$emit(`newAnswer`, newAnswer);
      },
      comment (newComment) {
        if (this.answer === this.currentQuestion.data.otherLabel) {
          this.$emit(`canValidate`, Boolean(newComment));
          this.$emit(`newAnswer`, `${this.answer} : ${newComment}`);
        }
      },
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// SingleChoice.vue?0ac51a6a